import React from 'react';
import { Popover as AntPopover, PopoverProps } from 'antd';

const Popover = ({ trigger = 'click', zIndex = 1, ...props }: PopoverProps) => {
  return <AntPopover trigger={trigger} zIndex={zIndex} {...props} />;
};

export default Popover;
